const state: () => any = () => ({
    mainMenu: null,
    cityList: null,
    citiesLoading: false
});

export default state;
